module.exports = __webpack_public_path__ + "img/nevi_teaser_desktop_connect_with_nevi.512cc0b3.png";